import { EmptyState, Badge } from "@z/ui";
import { LayoutDashboard } from "lucide-react";
export function DashboardsPane() {
  return (
    <div className="h-full overflow-y-auto px-7 py-7">
      <header className="flex items-center gap-3">
        <LayoutDashboard className="size-5 text-nav-teal" />
        <h1 className="text-xl font-semibold tracking-tight">Dashboards</h1>
        <Badge>Coming soon</Badge>
      </header>
      <EmptyState
        icon={<LayoutDashboard />}
        title="A place for your bigger picture"
        description="Custom dashboards will bring your metrics and panels together. This space is ready for what you want to track."
      />
    </div>
  );
}
